<template>
  <main class="page contacts-page">
    <div class="contacts-page__container">
      <ul class="breadcrumbs">
        <li class="breadcrumbs__item">
          <router-link :to="{ name: 'home'}">Главная</router-link>
        </li>
        <li class="breadcrumbs__item">
          <span>Контакты</span>
        </li>
      </ul>
      <h1 class="contacts-page__title">Контакты</h1>
      <div class="contacts-page__content">
        <aside class="contacts-page__info">
          <ul class="contacts-page__info__list">
            <li class="contacts-page__info__list__item">
              <a :href="'tel:' + $store.state.contacts.phone" rel="nofollow" class="contacts-page__info__list__link">
                <i aria-hidden="true">
                  <phone-icon/>
                </i>
                <span>{{ $store.state.contacts.phone  }}</span>
              </a>
            </li>
            <li class="contacts-page__info__list__item" v-if="$store.state.contacts.phone2">
              <a :href="'tel:' + $store.state.contacts.phone2" rel="nofollow" class="contacts-page__info__list__link">
                <i aria-hidden="true">
                  <phone-icon/>
                </i>
                <span>{{ $store.state.contacts.phone2  }}</span>
              </a>
            </li>
            <li class="contacts-page__info__list__item" v-if="$store.state.contacts.phone3">
              <a :href="'tel:' + $store.state.contacts.phone3" rel="nofollow" class="contacts-page__info__list__link">
                <i aria-hidden="true">
                  <phone-icon/>
                </i>
                <span>{{ $store.state.contacts.phone3  }}</span>
              </a>
            </li>
            <li class="contacts-page__info__list__item" v-if="$store.state.contacts.phone4">
              <a :href="'tel:' + $store.state.contacts.phone4" rel="nofollow" class="contacts-page__info__list__link">
                <i aria-hidden="true">
                  <phone-icon/>
                </i>
                <span>{{ $store.state.contacts.phone4  }}</span>
              </a>
            </li>
            <li class="contacts-page__info__list__item">
              <a :href="'mailto:' + $store.state.contacts.email" rel="nofollow" class="contacts-page__info__list__link">
                <i aria-hidden="true">
                  <mail-icon/>
                </i>
                <span>{{ $store.state.contacts.email }}</span>
              </a>
            </li>
            <li class="contacts-page__info__list__item">
            <span class="contacts-page__info__list__link">
              <i aria-hidden="true">
                <map-icon/>
              </i>
              <span>{{ $store.state.contacts.address }}</span>
            </span>
            </li>
          </ul>
        </aside>
        <div class="contacts-page__map">
          <client-only>
            <yandex-map :coords="center" :zoom="15" :settings="settings">
              <ymap-marker marker-id="0" :coords="coords"/>
            </yandex-map>
          </client-only>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import PhoneIcon from 'components/svg/PhoneIcon.vue'
import MailIcon from 'components/svg/MailIcon.vue'
import MapIcon from 'components/svg/MapIcon.vue'
import { loadYmap, yandexMap, ymapMarker } from 'vue-yandex-maps'
import ClientOnly from 'vue-client-only'

export default {
  async asyncData ({ store }) {
    await store.dispatch('HOME_PAGE')
  },
  name: 'ContactsPage',
  components: {
    MapIcon,
    MailIcon,
    ClientOnly,
    PhoneIcon,
    yandexMap,
    ymapMarker
  },
  data () {
    return {
      center: [42.928683, 47.552391],
      coords: [42.928683, 47.552391],
      settings: {
        apiKey: '4265658a-0ac8-4cda-9fc1-ced9f192d154',
        lang: 'ru_RU',
        coordorder: 'latlong',
        version: '2.1'
      }
    }
  },
  async mounted () {
    await loadYmap({
      ...this.settings,
      debug: false
    })
    // eslint-disable-next-line no-undef
    await ymaps.geocode(this.$store.state.contacts.address ? this.$store.state.contacts.address : 'Россия').then(res => {
      this.coords = res.geoObjects.get(0).geometry.getCoordinates()
      this.center = res.geoObjects.get(0).geometry.getCoordinates()
    })
  },
  metaInfo () {
    return this.$store.state.department ? this.$seo(
      'common',
      this.$store.state.department.title,
      'управление образования, образование',
      'Сайт ' + this.$store.state.department.title + '. В сайте есть информация о проектах, учреждениях, актуальные новости и обращение к руководителю',
      this.$store.state.department.title,
      this.$store.state.api + this.$store.state.department.img_head,
      'Сайт ' + this.$store.state.department.title + '. В сайте есть информация о проектах, учреждениях, актуальные новости и обращение к руководителю'
    ) : this.$seo('common', '', '', '', '', '', '')
  }
}
</script>
